import React, {Component} from 'react';

import Aux from '../auxilliary';

import classes from './Layout.css'

import Toolbar from '../../components/Navigation/Toolbar/toolbar';

import SideDrawer from '../../components/Navigation/SideDrawer/sideDrawer';

import {connect} from 'react-redux';

import BottomNav from '../../components/BottomNav/bottomnav';



class Layout extends Component{//this was turned into class based component as
    
    state={
        showSideDrawer:false
    }

    
    sideDrawerCloseHandler=()=>{
        this.setState({showSideDrawer:false})
        
    }
    
    sideDrawerToggleHandler=()=>{
        
        this.setState((prevState)=>{
            return {showSideDrawer:!prevState.showSideDrawer};
        });
        }
    
    render(){
        
        return(
        
        <Aux>
    
            <Toolbar isLogged={this.props.isLogged} drawerToggleClicked={this.sideDrawerToggleHandler}/>
            <SideDrawer isLogged={this.props.isLogged} open={this.state.showSideDrawer} closed={this.sideDrawerCloseHandler}/>
            <main className={classes.Content}>
                {this.props.children}
            </main>
        
            {!this.props.toggleHideHofNav && !this.props.toggleHideDriversNav && !this.props.toggleHideTeamsNav?<BottomNav />:null}
        </Aux>
        
        );
    }
}

const mapStateToProps=state=>{//mapStateToProps is commonly used name, but you could name it differently. The state is Redux state. Note: create this constant after the class above
    
    return {
        
        isLogged: state.auth.token !== null,
        toggleHideHofNav: state.hide.hideHOF,
        toggleHideDriversNav:  state.hide.hideDrivers,
        toggleHideTeamsNav: state.hide.hideTeams
    };
}


export default connect(mapStateToProps)(Layout);


// WEBPACK FOOTER //
// ./src/hoc/Layout/Layout.js